import { Person } from './person';
import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractApproval } from './abstract-approval';
import { ApprovalRequestInfo } from './approval-request-info';

@inheritSerialization(AbstractApproval)
export class ApprovalActivity extends AbstractApproval {
  @autoserializeAs(Date)
  submittedDate: Date;

  @autoserializeAs(ApprovalRequestInfo)
  approvalInfo: Array<ApprovalRequestInfo>;

  @autoserializeAs(Person)
  requester: Person;

  static OnDeserialized(instance: ApprovalActivity, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['submittedDate'])) {
      instance.submittedDate = DateUtil.deserializeDate(json['submittedDate']);
    }
  }
}
